import { DataAttributes } from "../types/DataAttributes";

// function to parse data attributes from the DOM
export const getDataAttributes = (
    node: any
  ) => {
    const d: any = {}
    for (const attr of node.attributes) {
        if (attr.nodeName.includes('data-betslip')) {
            const key = attr.nodeName.replace('data-', '').replaceAll('-','_');
            d[key] = attr.nodeValue;
        }
    }
    
    const dataMap: DataAttributes = {
        apiUrl: d.betslip_url,
        selectedSide: d.betslip_side,
        selectedSportsbook: d.betslip_sportsbook
    }
    return dataMap;
}
